import Utils from "../../../../../shared/utils";

export const THIRD_SECTION_IMAGE = Utils.buildProductPageImageLink(
  "mort/reduced-mort/third-section-desk.svg"
);